export default {
    PtHeaderWidgetCaseTime: {
        tooltip: '項目計時',
    },
};
